import { motion } from "framer-motion";
import { ShieldCheck, Zap, Globe2, Users } from "lucide-react";

const REASONS = [
  {
    icon: Globe2,
    title: "Global Standards",
    desc: "Enterprise-grade security, compliance and reporting baked into every engagement from day one.",
  },
  {
    icon: Zap,
    title: "Live in Weeks",
    desc: "Recruiting, training and ramp handled by us. Most teams go live in 2–6 weeks, not months.",
  },
  {
    icon: Users,
    title: "Elite Talent",
    desc: "World-class, English-fluent professionals — anchored by our Philippines delivery hub.",
  },
  {
    icon: ShieldCheck,
    title: "Fully Managed",
    desc: "Dedicated team leads, QA and performance dashboards mean you stay in control without the admin.",
  },
];

export const WhyChooseUs = () => {
  return (
    <section id="why" data-testid="why-section" className="bg-[#0A0A0A] text-white py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="font-mono-nw text-xs tracking-[0.25em] uppercase text-[#002DFF]">
              Why NovaWorks
            </span>
            <h2 className="mt-4 font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Built to be an
              <br />
              extension of
              <br />
              your team
            </h2>
            <p className="mt-8 text-white/60 leading-relaxed max-w-md">
              We combine the operational rigor of an enterprise with the agility of a
              partner who actually cares about your numbers. Our delivery centers in the
              Philippines give you a deep, reliable bench of talent at a fraction of
              in-house cost.
            </p>

            <div className="mt-10 border-t border-white/15 pt-8 grid grid-cols-2 gap-8">
              <div>
                <div className="font-display font-black text-4xl text-[#002DFF]">15+</div>
                <div className="mt-1 text-xs uppercase tracking-[0.15em] text-white/50">Industries served</div>
              </div>
              <div>
                <div className="font-display font-black text-4xl text-[#002DFF]">24/7</div>
                <div className="mt-1 text-xs uppercase tracking-[0.15em] text-white/50">Always-on coverage</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/15 border border-white/15">
            {REASONS.map((r, i) => {
              const Icon = r.icon;
              return (
                <motion.div
                  key={r.title}
                  data-testid={`reason-${i}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="bg-[#0A0A0A] p-8 md:p-10"
                >
                  <Icon className="w-7 h-7 text-[#002DFF]" strokeWidth={1.5} />
                  <h3 className="mt-6 font-display font-bold uppercase tracking-tight text-lg">
                    {r.title}
                  </h3>
                  <p className="mt-3 text-white/55 text-sm leading-relaxed">{r.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
